import React from 'react';

import toolStyles from './ToolTip.scss';

const ToolTip = () => (
  <div className={toolStyles.proTip}>
    <p>
      Pro tip: You can ask your household member to send an invite from the app.
    </p>
  </div>
);

export default ToolTip;
